import { Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PHONE_NUMBER = '+4917624938417';
const PHONE_DISPLAY = '+49 176 2493 8417';

const Footer = () => {
  const { t } = useTranslation();

  const quickLinks: { href: string; labelKey: string; isRoute?: boolean }[] = [
    { href: '#advantages', labelKey: 'simonsMarketing.nav.advantages' },
    { href: '#process', labelKey: 'simonsMarketing.nav.process' },
    { href: '#testimonials', labelKey: 'simonsMarketing.nav.testimonials' },
    { href: '#faq', labelKey: 'simonsMarketing.nav.questions' },
    { href: '/free-analysis', labelKey: 'simonsMarketing.nav.free_analysis', isRoute: true },
  ];

  return (
    <footer className="bg-gray-950 border-t border-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <a href="#" className="flex items-center gap-2 mb-4">
              <img src="/MainLogo.webp" alt="Simons Marketing Logo" className="w-8 h-8 object-contain" />
              <span className="text-xl font-bold text-white tracking-tight">
                Simons <span className="text-emerald-400">Marketing</span>
              </span>
            </a>
            <p className="text-gray-500 text-sm leading-relaxed">
              {t('simonsMarketing.footer.description')}
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">{t('simonsMarketing.footer.quick_links')}</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  {link.isRoute ? (
                    <Link
                      to={link.href}
                      className="text-gray-500 hover:text-emerald-400 text-sm transition-colors"
                    >
                      {t(link.labelKey)}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-gray-500 hover:text-emerald-400 text-sm transition-colors"
                    >
                      {t(link.labelKey)}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">{t('simonsMarketing.footer.contact')}</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${PHONE_NUMBER}`}
                  className="flex items-center gap-2 text-gray-500 hover:text-emerald-400 text-sm transition-colors"
                >
                  <Phone className="w-4 h-4" />
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@simons-marketing-solutions.com"
                  className="flex items-center gap-2 text-gray-500 hover:text-emerald-400 text-sm transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  info@simons-marketing-solutions.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-900">
          <p className="text-center text-gray-600 text-sm">
            &copy; {new Date().getFullYear()} {t('simonsMarketing.footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
